module.exports = __webpack_public_path__ + "img/expand-icon.d4659f93.svg";